import type { ConciergeCard } from "@/hooks/useAiConcierge";
import ConciergeListingCard from "./ConciergeListingCard";

interface Props {
  cards: ConciergeCard[];
  onOpenDetail: (slug: string) => void;
}

/**
 * In-thread listings as a horizontal, snap-scrolling row (not a column) so the
 * conversation stays readable. Native overflow-x, the per-card photo carousel
 * owns the only embla x-axis.
 */
const ConciergeListingsRail = ({ cards, onOpenDetail }: Props) => {
  if (!cards.length) return null;
  return (
    <div className="mt-2 -mx-1 flex gap-3 overflow-x-auto px-1 pb-1 snap-x snap-mandatory scrollbar-none">
      {cards.map((c) => (
        <ConciergeListingCard
          key={c.slug}
          card={c}
          onOpenDetail={onOpenDetail}
          className="w-[78%] max-w-[15rem] shrink-0 snap-start"
        />
      ))}
    </div>
  );
};

export default ConciergeListingsRail;
